import { Routes } from '@angular/router';

export const CLIENT_SHELL_CHILD_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('../../pages/client/dashboard/dashboard').then((m) => m.ClientDashboard),
    data: { title: 'Client Dashboard', description: 'An overview of your account.' },
  },
  {
    path: 'trading',
    pathMatch: 'full',
    redirectTo: 'trading/list',
  },
  {
    path: 'trading/list',
    loadComponent: () =>
      import('../../pages/client/trading/trading').then((m) => m.Trading),
    data: { title: 'Trading', description: 'Place and track currency trades.' },
  },
  {
    path: 'trading/book',
    loadComponent: () =>
      import('../../pages/common/list-trades/book-trade/book-trade').then((m) => m.BookTrade),
    data: { title: 'Book Trade', description: 'Book a new currency trade.' },
  },
  {
    path: 'trading/:tradeId',
    loadComponent: () =>
      import('../../pages/common/list-trades/view-trade/view-trade').then((m) => m.ViewTrade),
    data: { title: 'Trade Status', description: 'View trade details and status.' },
  },
  {
    path: 'beneficiary',
    loadComponent: () =>
      import('../../pages/client/beneficiary/list-beneficiary/list-beneficiary').then(
        (m) => m.ListBeneficiary
      ),
    data: { title: 'Beneficiary', description: 'Manage who you send payments to.' },
  },
  {
    path: 'remitters',
    loadComponent: () =>
      import('../../pages/client/remitter/list-remitter/list-remitter').then((m) => m.ListRemitter),
    data: { title: 'Remitters', description: 'Third parties who send funds into this client account.' },
  },
  {
    path: 'remitters/:remitterId',
    loadComponent: () =>
      import('../../pages/client/remitter/view-remitter/view-remitter').then((m) => m.ViewRemitter),
    data: { title: 'Remitter Details', description: 'Review a remitter, its notes and documents.' },
  },
  {
    path: 'payments',
    loadComponent: () =>
      import('../../pages/client/payments/payments').then((m) => m.Payments),
    data: { title: 'Payments', description: 'Send and track payments.' },
  },
  {
    path: 'payments/batch',
    loadComponent: () =>
      import('../../pages/common/list-payment/batch-payment/batch-payment').then((m) => m.BatchPayment),
    data: { title: 'New Payments', description: 'Create a multi-currency payment batch.' },
  },
  {
    path: 'balances',
    loadComponent: () =>
      import('../../pages/client/balances/balances').then((m) => m.ClientBalancesPage),
    data: { title: 'Balances', description: 'View your account balances.' },
  },
  {
    path: 'statements',
    loadComponent: () =>
      import('../../pages/client/statements/statements').then((m) => m.ClientStatementsPage),
    data: { title: 'Statements', description: 'Every movement across your accounts.' },
  },
  {
    path: 'fund-account',
    loadComponent: () =>
      import('../../pages/client/fund-account/fund-account').then((m) => m.FundAccount),
    data: {
      title: 'Fund Account',
      description: 'Add money by bank transfer using your dedicated account details.',
    },
  },
  {
    path: 'company-users',
    loadComponent: () =>
      import('../../pages/client/company-users/company-users').then((m) => m.CompanyUsers),
    data: {
      title: 'Company Users',
      description: 'Directors, Beneficial Owners, and Authorised Users on record.',
    },
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('../../pages/common/profile/profile').then((m) => m.Profile),
    data: { title: 'My Profile' },
  },
];
